import React, { useState, useEffect } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Tooltip,
  IconButton,
  TextField,
  Grid
} from "@mui/material";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { TextValidator } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { canWrite } from '../../../../utils/privilegeUtils';

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const dateFormat = (value) => {
    if (!value || value === "None") return "";

    const m = moment(value, ["YYYY-MM-DD", "DD-MM-YYYY", "DD/MM/YYYY"], true);

    return m.isValid() ? m.format("DD/MM/YYYY") : "";
};


export default function EInvoiceRepository() {
    const [openAndCloseModel, setOpenAndCloseModel] = useState(false);
    const [fileName, setFileName] = useState("");
    const [fileDataToUpload, setFileDataToUpload] = useState("");
    const [showSuccessOnly, setShowSuccessOnly] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    //...............For Error Message..........................
    const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
        useState("hidden");
    const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
        useState("none");
    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForTableSearch, setRecordForTableSearch] = useState([]);

    const [loaderForTable, setLoaderForTable] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [responseData, setResponseData] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [selectedOption, setSelectedOption] = useState("");

    // Function to open Snackbar
    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);
    };

    // Function to close Snackbar
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity("success");
        setResponseMessage("");
    };

    const handleBackNavigation = () => {
        history.push("/repoCards");
    };

    const handleToastifyNotification = (uploadFailReason, color) => {
        handleSnackbarOpen(uploadFailReason, color);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setResponseMessage("");
        }, 7000);
        return () => clearTimeout(timer);
    }, [responseMessage]);

    //.............Open And Close Event For Model.............
    const handleOpenAndClose = () => {
        setOpenAndCloseModel(!openAndCloseModel);
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        setFileDataToUpload("");
        setFileName("");
    };

    const fileUploadCancelButtonHandler = () => {
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        setFileDataToUpload("");
        setFileName("");
    };

    //.......Handle Search....................
    const handleSearch = (e) => {
        let Search = e.target.value.trim();
        const searchName = recordForTableSearch.filter((v) => {
            return (
                String(v.gstr_upload_file_type)
                    .toLowerCase()
                    .indexOf(Search.toLowerCase()) >= 0 ||
                String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
                0 ||
                String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
                0 ||
                String(moment(v.tax_period, "MMYYYY").format("MM-YYYY")).indexOf(
                    Search
                ) >= 0 ||
                String(
                    moment(v.upload_date, "YYYY-MM-DD").format("DD-MM-YYYY")
                ).indexOf(Search) >= 0
            );
        });
        setRecordForTable(searchName);
    };

    //........For Succesfull Message..................
    const functionForSuccesfullMessageAndErroeMessage = (
        color,
        visible,
        display,
        message
    ) => {
        setColorForErrorMessage(color);
        setErrorMessageVisibilityStyle(visible);
        setErrorMessageDisplayStyle(display);
        setErrorMessage(message);
    };

    //.............File Upload Data Saving in useState..............
    const handleFileUpload = (e) => {
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        if (e.target.files.length) {
            const file_data = e.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setFileDataToUpload(file_value);
            };
            e.target.value = null;
        }
    };

    //......Submit Event For File Upload in axios.......
    const handleSubmitEvent = (e) => {
        if (fileName === "") {
            handleSnackbarOpen("Please Upload The File!", "error");
            return;
        }
        if (selectedOption === "") {
            handleSnackbarOpen("Please Select File Type!", "error");
            return;
        }

        setLoading(true);
        axios
            .post(`/e_invoice_repo_upload`, {
                file: fileDataToUpload,
                gstin: localStorage.getItem("gst"),
                business_entity_id: localStorage.getItem('business_entity_id'),
                file_type: selectedOption,
                document_name: fileName
            })
            .then((res) => {
                getApiForEinvoiceRepo();
                if (res.data.Status === true) {
                    functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
                    getApiForEinvoiceRepo();
                    // handleSnackbarOpen("File uploaded successfully", "success");
                    resetFileUpload();
                } else {
                    handleSnackbarOpen(res.data.message, "error");
                    resetFileUpload();
                }
            })
            .catch((error) => {
                handleSnackbarOpen(error.response.data.Message, "error");
                resetFileUpload();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const resetFileUpload = () => {
        setFileDataToUpload(null);
        setFileName("");
        setSelectedOption('');
    };

    //.......................Get Api For Gst................
    const getApiForEinvoiceRepo = () => {
        setLoaderForTable(true);
        axios
            .get(`/get_e_invoice_repo_upload_summary/${localStorage.getItem("gst")}`)
            .then((res) => {
                if (res.data.status === true) {
                    setLoaderForTable(false);
                    setRecordForTable(res.data.record);
                    setRecordForTableSearch(res.data.record);
                } else {
                    setLoaderForTable(false);
                    alert(res.data.message);
                }
            })
            .catch(() => setLoaderForTable(false));
    };

    const newReconModalClose = () => {
        setFileName("");
        setFileDataToUpload("");
        setSelectedOption("");
        setErrorMessage("");
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
    };

    useEffect(() => {
        getApiForEinvoiceRepo();
    }, []);

    const handleDropdownChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const filteredRecords = recordForTable.filter(
        (v) =>
            !(v.upload_status === "Failed" && v.upload_fail_reason === "Latest Data Already Present")
    );

    return (
        <React.Fragment>
            <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
                <Tooltip title="Back" arrow>
                 <IconButton
                   onClick={handleBackNavigation}
                   sx={{
                     borderRadius: '50%',
                     padding: '6px',
                     color: '#263238',
                     fontSize: '20px',
                     backgroundColor: '#ffffff',
                     height: '36px',
                     width: '36px',
                     '&:hover': {
                       backgroundColor: '#455a64',
                       color: '#ffffff',
                     },
                     boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                     transition: 'background-color 0.3s ease',
                   }}
                 >
                   <ArrowBackIcon sx={{ fontSize: '20px' }} />
                 </IconButton>
               </Tooltip>
      </div>
            {canWrite("E-INVOICE RECONCILIATION") && (
            <BoxWrapper boxTitle="E-Invoice Repository Upload">
                <ValidatorForm
                    onSubmit={(e) => {
                        e.preventDefault();
                        if (fileName && fileDataToUpload) {
                            handleSubmitEvent(e);
                        }
                    }}
                    onError={(errors) => console.log(errors)}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '15px' }}>
                            {/* Upload Button */}
                            <div style={{ minWidth: '100px' }}>
                                <label
                                    className="button-primary"
                                    style={{
                                        width: "100%",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        padding: "8px",
                                        display: 'block'
                                    }}
                                >
                                    Upload
                                    <input
                                        type="file"
                                        accept=".xlsx,.zip"
                                        onChange={handleFileUpload}
                                        hidden
                                    />
                                </label>
                            </div>

                            {/* File name field */}
                            <div style={{ flex: '0 0 300px' }}>
                                <TextField
                                    placeholder="Choose file"
                                    value={fileName}
                                    variant="standard"
                                    fullWidth
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>

                            {/* File Type Dropdown */}
                            <div style={{ flex: '0 0 200px' }}>
                                <FormControl variant="standard" fullWidth>
                                    <InputLabel>File Type</InputLabel>
                                    <Select
                                        value={selectedOption}
                                        onChange={handleDropdownChange}
                                        label="Select Option"
                                    >
                                        <MenuItem value="E-invoice Portal">E-invoice Portal</MenuItem>
                                        <MenuItem value="E-invoice GST">E-invoice GST</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {/* Button Group */}
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <div style={{ minWidth: '100px' }}>
                                    <button
                                        className="button-primary"
                                        type="submit"
                                        style={{ width: '100%', padding: '8px' }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Submitting...' : 'Submit'}
                                    </button>
                                </div>

                                <div style={{ minWidth: '100px' }}>
                                    <button
                                        type="button"
                                        className="button-outlined-secondary"
                                        onClick={newReconModalClose}
                                        style={{ width: '100%', padding: '8px' }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ValidatorForm>
                {errorMessage && (
                    <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
                )}
            </BoxWrapper>
            )}

            {/*..................Table.......................*/}
            <BoxWrapper
                boxTitle="E-Invoice History"
                enableSearchInput={true}
                searchInputPlaceholder="Search..."
                searchInputOnchange={handleSearch}
                enableAddButton={true}
                addButtonLabel="Refresh"
                addButtonHandlerFn={getApiForEinvoiceRepo}
            >
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>EINVOICE UPLOAD FILE</th>
                                <th>TAX PERIOD</th>
                                <th>FINANCIAL YEAR</th>
                                <th>GENERATION DATE</th>
                                <th>UPLOAD DATE</th>
                                <th>STATUS</th>
                                <th>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={showSuccessOnly}
                                            onChange={() => setShowSuccessOnly(!showSuccessOnly)}
                                        />
                                        Show Success Only
                                    </label>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordForTable.map((v, index) => {
                                let statusText = v.upload_status;
                                if (v.upload_status === "Success") {
                                    statusText = "Success";
                                } else if (v.upload_status === "Initiated") {
                                    statusText = "Initiated";
                                } else if (v.upload_status === "In Progress") {
                                    statusText = "In Progress";
                                }

                                if (showSuccessOnly && v.upload_status !== "Success") {
                                    return null;
                                }

                                return (
                                    <tr key={index}>
                                        <td style={{ textTransform: "capitalize" }}>{v.e_invoice_upload_file_type}</td>
                                        <td style={{ textTransform: "capitalize" }}>{v.tax_period}</td>
                                        <td>{v.financial_year !== "None" ? v.financial_year : ""}</td>
                                        <td style={{ textTransform: "capitalize" }}>
                                            {dateFormat(v.generation_date)}

                                        </td>
                                        <td style={{ textTransform: "capitalize" }}>
                                            {dateFormat(v.upload_date)}

                                        </td>
                                        <td>{statusText}</td>
                                        <td>
                                            {v.upload_status ? (
                                                <div
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleToastifyNotification(v.upload_fail_reason, v.upload_status === "Success" ? 'success' : 'error')}
                                                >
                                                    <VisibilityOutlinedIcon
                                                        className="action-icon-button showIcon"
                                                        style={{ color: v.upload_status === "Success" ? "#2938c2" : v.upload_status === "Initiated" ? "#b4bfbf" : "red" }}
                                                    />
                                                </div>
                                            ) : (
                                                <VisibilityOutlinedIcon
                                                    className="action-icon-button showIcon"
                                                    onClick={() => alert("Data Uploaded")}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                            {loaderForTable ? (
                                <tr>
                                    <td
                                        colSpan={7}
                                        style={{
                                            color: "black",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Loading…Please wait
                                    </td>
                                </tr>
                            ) : recordForTable.length === 0 ? (
                                <tr>
                                    <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
                                        No Data Found!
                                    </td>
                                </tr>
                            ) : (
                                ""
                            )}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>

            {responseData && (
                <div>
                    <p style={{ fontSize: '20px', color: 'green' }}>DOWNLOADED GSTR DATA</p>
                    <p>{responseData}</p>
                </div>
            )}

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={2}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                </MuiAlert>
            </Snackbar>

        </React.Fragment>
    );
}